import { Module } from "vuex"
import { ResponseUserInfo } from "@/interface/common"
import {clearCookies} from "@/utils/index"

export interface UserInterface {
  user: ResponseUserInfo | null
}

const userStr = sessionStorage.getItem('userInfo')
const userInit = userStr ? JSON.parse(userStr) as ResponseUserInfo : null;
if (!userInit) {
  document.cookie = ""
}
const state: UserInterface = {
  user: userInit
}
const mutations = {
  SET_USER(state: UserInterface, data: ResponseUserInfo) {
    sessionStorage.setItem('userInfo', JSON.stringify(data))
    state.user = data;
  },
  CLEAR_USER(state: UserInterface) {
    sessionStorage.clear();
    clearCookies();
    location.reload();
    // document.cookie = `mobile='';password=''`
    state.user = null
  },
}
const getters = {
  isLogin(state: UserInterface): boolean {
    return !!state.user;
  }
}
export const User: Module<UserInterface, {}> = {
  state,
  mutations,
  getters
}